import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, Attribute, ViewChild
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl, AbstractControl, Validator, ValidatorFn
} from '@angular/forms';
import * as moment from 'moment-timezone';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {UserContext} from '../services/user-context';
import {FileInfo, FileRestrictions, SelectEvent, UploadComponent} from '@progress/kendo-angular-upload';
import {ApiService} from '../services/api';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

@Component({
  selector: 'app-profile-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'profile-dialog.template.html',
  styles: [
    "app-profile-dialog mat-dialog-container {padding:0;}",
    "app-profile-dialog mat-dialog-content.mat-dialog-content {background:#f7fafc;padding:24px;}",
    "app-profile-dialog mat-dialog-actions {display:flex;flex-direction: row;justify-content: space-between;}"
  ]
})

export class ProfileDialogComponent implements OnInit {
  @ViewChild('uploader', { static: true }) public uploader: UploadComponent;

  public form: FormGroup;
  public formErrors = {
    lastName: '',
    firstName: '',
    email: '',
    role: '',
    password: '',
    confirm: ''
  };
  countries = ['US', 'CA'];
  timezones:string[];
  avatar: any;
  user:any;
  selectedFile:FileInfo;
  imagePreviews: any[] = [];
  uploadUrl = '';
  uploadRestrictions: FileRestrictions = {
    allowedExtensions: ['.jpg', '.png']
  };

  public validationMessages = {
    lastName: {minlength: 'Minimum 2 characters', required: 'Last name required'},
    firstName: {minlength: 'Minimum 2 characters', required: 'First name required'},
    email: {minlength: 'Valid email required', required: 'Valid email required', email: 'Valid email required'},
    role: {required: 'Role is required'},
    locations: {required: 'Location is required'},
    password: {minlength: 'Minimum 8 characters', required: 'Password is required'},
    confirm: {minlength: 'Retype password', required: 'Retype password', equalTo: 'Passwords do not match'}

  };

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<ProfileDialogComponent>,
              private userContext: UserContext,
              public httpClient: HttpClient,
              private api: ApiService,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    this.user = data;
    this.timezones = Array.from(new Set<string>(moment.tz.zonesForCountry('US').concat(moment.tz.zonesForCountry('CA')))).sort();
  }

  public ngOnInit(): void {
    this.buildForm();
  }

  public buildForm() {
    this.form = this.formBuilder.group({
      lastName: new FormControl( this.user ? this.user.lastName : '', [
        Validators.required,
        Validators.minLength(2)
      ]),
      firstName: new FormControl(this.user ? this.user.firstName : '', [
        Validators.required,
        Validators.minLength(2)
      ]),
      email: new FormControl(this.user ? this.user.email : '', [
        Validators.required,
        Validators.email,
        Validators.minLength(3)
      ]),
      country: new FormControl(this.user ? this.user.country : '', [
        Validators.required
      ]),
      phone: new FormControl(this.user ? this.user.phone : '', [
        Validators.minLength(10)
      ]),
      titles: new FormControl(this.user ? (this.user.titles || []).join(" ") : '', [
      ]),
      timezone: new FormControl(this.user ? this.user.timezone || moment.tz.guess() : moment.tz.guess(), [
        Validators.required
      ]),

    });

    this.form.valueChanges
      .subscribe(data => this.onValueChanged(data));
  }

  public onValueChanged(data?: any): void {
    if (!this.form) { return; }
    const form = this.form;

    for ( const field of Object.keys( this.formErrors) ) {
      this.formErrors[field] = '';
      const control = form.get(field);

      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[field];

        for ( const key of Object.keys( control.errors ) ) {
          this.formErrors[field] = messages[key];
        }
      }
    }
  }

  public clearEventHandler(): void {
    this.selectedFile = null;
    this.imagePreviews = [];
  }

  public selectEventHandler(e: SelectEvent): void {
    const that = this;

    e.files.forEach((file) => {
      console.log(`File selected: ${file.name}`);

      this.selectedFile = file;
      this.api.get<any>(`/user/${this.userContext.user.reference}/avatar`,
        new HttpParams().set("contentType", file.rawFile.type)
      ).subscribe( result => {
        this.avatar = result;
        console.log("Url: " + JSON.stringify(result));
        this.uploadUrl = result.signedUrl;
      }, (error) => {
        console.log("Error getting avatar url");
      });

      if (!file.validationErrors) {
        const reader = new FileReader();

        reader.onload = function (ev) {
          const image = {
            src: ev.target['result'],
            uid: file.uid
          };

          that.imagePreviews.unshift(image);
        };

        reader.readAsDataURL(file.rawFile);
      }
    });
  }

  public completeEventHandler() {
    this.user.picture = this.avatar.url;
    this.user = Object.assign(this.user, this.form.value);
    this.dialogRef.close(this.user);
  }

  public isAdministrator() {
    return this.userContext.hasRole('administrator');
  }

  public isManager() {
    return this.userContext.hasRole('manager');
  }

  public isOwner() {
    return this.userContext.hasRole('owner');
  }

  public save() {
    if( this.selectedFile ) {
      console.log("Saving " + this.selectedFile.name + " with extension: " + this.selectedFile.extension);

      let formData = new FormData();
      for (let key of Object.keys(this.avatar.post.fields) ){
        formData.append(key, this.avatar.post.fields[key])
      }
      formData.append("Content-Type", this.selectedFile.rawFile.type);
      formData.append("file", this.selectedFile.rawFile);

      //console.log("Using formdataa: "  +JSON.stringify(formData.,null,4));
      this.httpClient.post(this.avatar.post.url, formData ).subscribe(next => {
        this.user = Object.assign(this.user, this.form.value, {picture:this.avatar.url});
        this.dialogRef.close(this.user);
      }, error => {
          console.log("Received error: " + JSON.stringify(error));
      });
      //this.uploader.uploadFiles();
    } else {
      this.user = Object.assign(this.user, this.form.value);
      this.dialogRef.close(this.user);
    }
  }

  public cancel() {
    this.dialogRef.close();
  }
}

export function equalityValidator(equalTo: string, hostError: boolean): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    const compareTo = control.root.get(equalTo);
    if ( hostError ) {
      return !compareTo || compareTo.value === control.value ? null : {'equalTo': {value: false}};
    } else {
      if ( compareTo && compareTo.touched ) {
        if ( compareTo.value !== control.value ) {
          compareTo.setErrors({'equalTo': {value: false}});
        } else {
          compareTo.setErrors( null );
        }
      }
      return null;
    }
  };
}
